import * as z from "zod";

export const RecognizeAudienceDateRange = z.enum([
  "30",
  "60",
  "90",
  "180",
  "all",
]);
export type RecognizeAudienceDateRange = z.infer<
  typeof RecognizeAudienceDateRange
>;

export const AUDIENCE_DATE_RANGES: Record<
  RecognizeAudienceDateRange,
  { label: string; days: number | null; interval: "week" | "month" }
> = {
  "30": { label: "Last 30 days", days: 30, interval: "week" },
  "60": { label: "Last 60 days", days: 60, interval: "week" },
  "90": { label: "Last 90 days", days: 90, interval: "month" },
  "180": { label: "Last 180 days", days: 180, interval: "month" },
  all: { label: "All time", days: null, interval: "month" },
};

export function getRecognizeAudienceDateWindow(
  dateRange: RecognizeAudienceDateRange,
  now = Temporal.Now.instant(),
) {
  const end = now.toZonedDateTimeISO("UTC").startOfDay().add({ days: 1 });
  const { days } = AUDIENCE_DATE_RANGES[dateRange];
  let start: Temporal.ZonedDateTime | null = null;
  if (days !== null) {
    start = end.subtract({ days });
  }

  return { start, end };
}
